
<button mat-icon-button (click)="trigger()">
  <mat-icon>refresh</mat-icon>
</button>
<div>
  <mat-form-field subscriptSizing="dynamic">
    <mat-label>Refresh interval</mat-label>
    <mat-select [formControl]="refreshIntervalControl">
      <mat-option value="5000">5s</mat-option>
      <mat-option value="25000">25s</mat-option>
      <mat-option value="60000">1m</mat-option>
      <mat-option value="180000">3m</mat-option>
      <mat-option value="600000">10m</mat-option>
      <mat-option value="-1">Never</mat-option>
    </mat-select>
  </mat-form-field>
  <mat-progress-bar *ngIf="progressBarValue" [value]="progressBarValue" mode="determinate"></mat-progress-bar>
</div>